import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';

export const AuthenticatedMessage: MessageHandler<undefined> = {
  send(payload = undefined, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.Authenticated, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is undefined {
    return payload === undefined;
  },
};
